import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { UserPermissionEnum } from '../../models/user-permissions.enum';
import { UserInformationService } from './user-information.service';

export type Permission = UserPermissionEnum | string;

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private readonly userInformationService = inject(UserInformationService);

  public readonly userPermissions$: Observable<string[]> =
    this.userInformationService.userPermissions$;

  public hasPermission(permission: Permission): Observable<boolean> {
    return this.userPermissions$.pipe(
      map((permissions) => PermissionService.hasPermissionValue(permissions, permission)),
    );
  }

  public hasAnyPermission(requiredPermissions: readonly Permission[]): Observable<boolean> {
    return this.userPermissions$.pipe(
      map((permissions) =>
        PermissionService.hasAnyPermissionValue(permissions, requiredPermissions),
      ),
    );
  }

  public static hasPermissionValue(
    permissions: readonly string[],
    requiredPermission: Permission | undefined,
  ): boolean {
    return !requiredPermission || permissions.includes(requiredPermission);
  }

  public static hasAnyPermissionValue(
    permissions: readonly string[],
    requiredPermissions: readonly Permission[] | undefined,
  ): boolean {
    return (
      requiredPermissions === undefined ||
      requiredPermissions.length === 0 ||
      requiredPermissions.some((item) => permissions.includes(item))
    );
  }
}
